import React from 'react';
import { Route, Switch } from "react-router-dom";
import OffersList from "./components/OffersList";
import OffersForm from "./components/OffersForm";
import styles from './Offers.module.css';

export default function Offers() {
    return (
        <div className={styles.container}>
            <div className={styles.offers}>
                <Switch>
                    <Route exact path={'/offers'} render={() => <OffersList />}/>
                    <Route exact path={'/offers/create'} render={() => <OffersForm />}/>
                    <Route exact path={'/offers/edit/:id'} render={() => <OffersForm />}/>
                </Switch>
            </div>
        </div>
    )
}
